// extracted by mini-css-extract-plugin
export default {"trigger":"AddContractDropdown_trigger__aNeXO","menu":"AddContractDropdown_menu__oX0uj"};